var _require = require('prettier/standalone'),
    concat = _require.doc.builders.concat;

var ArrayTypeName = {
  print: function print(_ref) {
    var node = _ref.node,
        path = _ref.path,
        _print = _ref.print;
    var stateMutability = '';

    if (node.baseTypeName.name === 'address' && node.baseTypeName.stateMutability) {
      stateMutability = concat([' ', node.baseTypeName.stateMutability]);
    }

    return concat([path.call(_print, 'baseTypeName'), stateMutability, '[', node.length ? path.call(_print, 'length') : '', ']']);
  }
};
module.exports = ArrayTypeName;